import React from 'react';
import { scrollToTop } from '~/helpers/scrollPage';
import { Menu } from '@qred/components-library';
import { Company } from '~/models/clients/company';
import { useClient } from '~/hooks/useClient';
import { useDispatch } from 'react-redux';
import {
  PostHogPageName,
  capturePostHogEvent,
} from '~/store/actions/posthogActions';
import { posthogEventNames } from '~/pages/Dashboard/constants';

export const CompanyItem: React.FC<{
  company: Company;
}> = ({ company }) => {
  const { setActiveCompany } = useClient();
  const dispatch = useDispatch();
  const onSwitchCompany = () => {
    setActiveCompany(company);
    scrollToTop();
    dispatch(
      capturePostHogEvent({
        product: PostHogPageName.DASHBOARD,
        eventName: posthogEventNames.CHANGE_COMPANY,
      })
    );
  };

  return <Menu.Item onClick={onSwitchCompany}>{company.companyName}</Menu.Item>;
};
